import fetchApi from '../../services/fetchApi'
import * as AT from './_types'
import moment from 'moment-timezone'
import { fetchPatients } from './patient-groups'

export const prepareBlastMessage = (queryParams, isEmail, locationId = null, allLocations = false) => (dispatch) => {
  const messageType = isEmail ? 'email' : 'text'
  queryParams.blast_message_type = messageType

  return dispatch(fetchPatients(queryParams, 1, locationId, allLocations)).then((response) => {
    if (queryParams['appointment_doctor_ids[]'].length === 0) {
      queryParams['appointment_doctor_ids[]'] = null
    }
    if (queryParams['appointment_location_ids[]'].length === 0) {
      queryParams['appointment_location_ids[]'] = null
    }
    dispatch({
      type: AT.BLASTS_PREPARE,
      isEmail,
      addresseeContactInfo: response,
      allLocationsSelected: allLocations,
      selectedDoctors: queryParams['appointment_doctor_ids[]'],
      selectedLocations: queryParams['appointment_location_ids[]'],
      range: queryParams['appointment_range[]'],
    })

    return Promise.resolve()
  })
}

export const handleBlastMessageFail = (err, isEmail) => (dispatch) => {
  const errorMessage = err.toString()
  dispatch({ type: AT.BLASTS_FETCH_FAIL, errorMessage, isEmail })
}

export const sendBlastMessage = ({
  bodyText,
  subject,
  isEmail,
  contactMap,
  patientFilter,
  media,
  locationId,
  allLocations,
}) => (dispatch) => {
  const params = {
    body: bodyText,
    subject,
    addressee_contact_map: contactMap,
    patient_filter: patientFilter,
    media,
    all_locations: allLocations,
  }
  if (locationId) params.active_location_id = locationId
  const postBody = JSON.stringify(params)

  const messageType = isEmail ? 'email' : 'text'

  return fetchApi(`/blasts/${messageType}`, 'POST', { body: postBody }).then(
    (response) => {
      dispatch({
        type: AT.MESSAGE_ADD_MEDIA,
        media: null,
        conversationId: null,
      })
      return response
    }).then(
    (response) => {
      dispatch({ type: AT.BLASTS_FETCH_SUCC, isEmail })
      return response
    },
  )
}

export const getOneBlast = blastId => () =>
  fetchApi(`/blasts/${blastId}`, 'GET').then(blast => Promise.resolve(blast))

const createTempScheduledFor = (cancelled, createdAt) =>
  cancelled ? '' : moment(createdAt).clone().add(30, 'minutes').format()

export const getAllBlasts = () => dispatch =>
  fetchApi('/blasts', 'GET').then((res) => {
    const blasts = res.map(({ id, created_at, scheduled_for, cancelled }) => ({
      id,
      createdAt: created_at,
      scheduledFor:
        scheduled_for || createTempScheduledFor(cancelled, created_at),
      // converts isCancelled to a boolean since it can be returned as undefinded null or true
      isCancelled: !!cancelled,
    }))

    dispatch({ type: AT.BLASTS_RECEIVE, blasts })

    return Promise.resolve()
  })

export const cancelBlast = blastId => () =>
  fetchApi(`/blasts/${blastId}`, 'DELETE')



// WEBPACK FOOTER //
// ./src/state/actions/blast-messages.js